import CacheRefreshRate from './CacheRefreshRate';

export default CacheRefreshRate;
